module.exports = __webpack_public_path__ + "resource/img/OrangeYellow.82f614a5.png";